import { CurrentState } from "../../state/currentState";
import { PastProfile } from "./pastProfileTypes";
import { buildKNNVector, knnDistanceWeighted, KNNDistanceWeights } from "./knnDistance";

/**
 * kNN으로 선택된 이웃들을 집계하여
 * 평균 dev 시간과 최종 손실률을 추정
 */
//kNN Aggregate 수정
export function knnAggregateWeighted(curr: CurrentState, pasts: PastProfile[], k = 3, weights?: KNNDistanceWeights) {
  const neighbors = [...pasts]
    .map((p) => ({
      p,
      d: knnDistanceWeighted(buildKNNVector(curr, p), weights),
    }))
    .sort((a, b) => a.d - b.d)
    .slice(0, k)
    .map((x) => x.p);

  return {
    avgDevTime: neighbors.reduce((s, p) => s + p.devTime, 0) / neighbors.length,
    avgFinalLoss: neighbors.reduce((s, p) => s + p.finalLoss, 0) / neighbors.length,
  };
}
